import React from 'react';
import './Header.css';

const Header = ({ onNavigateHome }) => {
  return (
    <header className="business-hub-header">
      <div className="header-container">
        <button 
          type="button" 
          className="header-brand-button" 
          onClick={onNavigateHome} 
          aria-label="Go to Business Idea Hub home page"
        >
          <div className="header-brand-wrapper">
            <div className="header-brand-content">
              <h1 className="header-brand-title">Business Idea Hub</h1>
              <p className="header-brand-subtitle">Top 50 Online Business Ideas</p>
            </div>
          </div>
        </button>
      </div>
    </header>
  );
};

export default Header;
